/**
 * A transição entre telas: o conteúdo novo entra pela opacidade, em 150ms.
 *
 * ── Por que pela API de animação, e não por CSS ───────────────────────────
 *
 * As telas trocam dentro do mesmo `<main>`: o React mantém o elemento quando o
 * tipo é o mesmo, e uma animação de CSS no `<main>` só rodaria na primeira
 * vez. Aqui a animação é disparada a cada troca de tela (ou de seção de um
 * submenu), sobre o que estiver no palco.
 *
 * ── O que não anima ───────────────────────────────────────────────────────
 *
 * A abertura da página (não há de onde vir), a troca de conversa dentro do
 * Atendimento (a chave não muda) e quem pediu menos movimento ao sistema.
 * Só a opacidade: deslocar a tela inteira cansa quem troca de tela o dia todo.
 */

import { useEffect, useRef, type RefObject } from 'react';

const DURACAO_MS = 150;

export function useTransicaoDeTela(palco: RefObject<HTMLElement | null>, tela: string): void {
  const anterior = useRef(tela);

  useEffect(() => {
    if (anterior.current === tela) return;
    anterior.current = tela;
    if (globalThis.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
    // A tela é o último filho do palco: antes dela vêm a barra do celular e as faixas.
    const conteudo = palco.current?.lastElementChild;
    if (!(conteudo instanceof HTMLElement) || typeof conteudo.animate !== 'function') return;
    conteudo.animate([{ opacity: 0 }, { opacity: 1 }], {
      duration: DURACAO_MS,
      easing: 'ease-out',
    });
  }, [palco, tela]);
}
